import React from "react";
import { Container, DeleteIntentButtonArea, ActionArea, FormArea, TitleArea } from "./Styled";
import { Formik, Form, FormikValues, FormikErrors, FormikTouched } from "formik";
import { Input } from "formik-antd";
import { Alert, Card } from "antd";
import * as Yup from "yup";
import {useIntl} from 'react-intl';
import { Entity } from "../../../../model/intent/types";
import { useDispatch } from "react-redux";
import Header from "../../../system/header";
import SaveButton from "../../../system/saveButton/SaveButton";
import ConfirmButton from "../../../system/confirmButton/ConfirmButton";
import ColorPicker from "../../../system/colorPicker/colorPicker";
import { deleteEntityAction, saveEntityAction } from "../../../../business/actions/entityActions";

type IntentFormProps = {
  entity?: Entity | null
};

const SignupSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required')
});

const EntityForm: React.FunctionComponent<IntentFormProps> = ({entity}) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const save = (values: FormikValues) => {
    dispatch(saveEntityAction.request(values as Entity))
  }

  const onDelete = (entityId: string) => {
    dispatch(deleteEntityAction.request(entityId));
  }

  const renderHeader = (values: FormikValues, errors: FormikErrors<any>, touched: FormikTouched<any>) => {
    return <Header>
      <TitleArea>
        <Input name='title' value={values.title} placeholder="Titre"></Input>
        {errors.title && touched.title ? (
          <Alert message={errors.title} type="error" showIcon />
        ) : null}
      </TitleArea>
      <ActionArea>
        <DeleteIntentButtonArea>
          <ConfirmButton onConfirm={() => onDelete(values.id)} confirmTitle={intl.formatMessage({id:'entity_manager.delete_confirm'})} danger>Supprimer</ConfirmButton>
        </DeleteIntentButtonArea>
        <SaveButton/>
      </ActionArea>
    </Header>
  }

  return (
    <Container>
      <Formik
      validationSchema={SignupSchema}
      enableReinitialize
      initialValues={{ id: entity?.id, title: entity?.title, color: entity?.color }}
      onSubmit={(values) => {
        save(values);
      }}
      render={({ values, errors, touched }) => {
        return<Form>
          {renderHeader(values, errors, touched)}
          <FormArea>
            <Card style={{ width: 290 }} title="Color">
              <ColorPicker name='color'/>
            </Card>
          </FormArea>
        </Form>
      }}
    />
    </Container>
  );
};

export default EntityForm;